(function () {
  function attachReviewCounts() {
    document.querySelectorAll('.product-benefits-grid__rating:not([data-count-synced])').forEach((row) => {
      if (row.classList.contains('product-benefits-grid__rating--has-count')) {
        row.setAttribute('data-count-synced', '');
        return;
      }

      const badge = row.querySelector('.jdgm-prev-badge');
      if (!badge) return;

      const count = badge.dataset.numberOfReviews;
      if (!count || count === '0') return;

      if (row.querySelector('.product-benefits-grid__review-count')) {
        row.setAttribute('data-count-synced', '');
        return;
      }

      const countEl = document.createElement('span');
      countEl.className = 'product-benefits-grid__review-count';
      countEl.setAttribute('aria-hidden', 'true');
      countEl.textContent = `(${count})`;
      row.appendChild(countEl);
      row.classList.add('product-benefits-grid__rating--has-count');
      row.setAttribute('data-count-synced', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachReviewCounts);
  } else {
    attachReviewCounts();
  }

  document.addEventListener('shopify:section:load', attachReviewCounts);
  window.setTimeout(attachReviewCounts, 500);
  window.setTimeout(attachReviewCounts, 1500);
})();
